import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "./auth.service";
import {SystemApp} from "../../constans/SystemConfigurations";
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private auth: AuthService, private router: Router) {
  }
  canActivate() {
    if(this.auth.IsLoggedIn()){
      return true;
    }

    // this.router.navigate(['sign-in'],{ queryParams: { } }).then(()=>{
    //   window.location.reload();
    // });;
    this.router.navigate([],{ queryParams: { loginOpenForm: 'true' } });
    return false
  }

}



@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard  {
  constructor(private auth: AuthService, private router: Router) {
  }
  canActivate(): Promise<boolean> {
    return this.auth.IsAdminLogin();
  }

}

/** Blocks the legacy admin frontend after it moved to a separate project. */
@Injectable({ providedIn: 'root' })
export class AdminDisabledGuard {
  constructor(private router: Router) {}

  canMatch(): UrlTree {
    return this.router.createUrlTree(['/']);
  }
}
